import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/source/admin/file/"

function baseApi() {
    function queryTotalCount(data) {
        return Post(baseUrl + "queryTotalCount", data)
    }

    function queryList(data) {
        return Post(baseUrl + "queryList", data)
    }

    function revertHotUpdateVersion(fileInfoId) {
        return Post(envConfig.formalServer + `/source/admin/revertVersion/${fileInfoId}`, null)
    }

    return {
        queryTotalCount,
        queryList,
        revertHotUpdateVersion
    }
}

export const fileAdminApi = baseApi()

